// @flow
import React from 'react';
import ReactFloater from 'react-floater';
import { withTranslation, WithTranslation } from 'react-i18next';
import Text from './Typography';
import Icon from './Icon';

export const FloaterStyles = {
  floater: {
    filter: 'drop-shadow(0px 4px 11px rgba(18, 6, 35, 0.08))',
    padding: '0',
    marginTop: '4px',
    backgroundColor: 'white',
    border: '1px solid #e0e0e0',
    borderRadius: '16px'
  }
};

type State = {
  open: boolean
}

type Props = {
  className: string,
  id: string,
  type: string,
  children: any,
  header: string,
  title: string,
  text: string,
  footer: string,
  placement: string // top, bottom, left, right, right-end,
  // right-start, left-end, left-start, auto
} & WithTranslation

class DictionaryFloater extends React.Component<Props, State> {
  state: State = {
    open: false
  };

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  handleClickOutside = (event: Object) => {
    if (event.target && event.target.className !== 'floater') {
      this.setState({
        open: false
      });
    }
  }

  toggle = () => {
    this.setState({
      open: !this.state.open
    });
  }

  props: Props;

  render() {
    const { children, header, title, text, footer, placement, t } = this.props;
    const { open } = this.state;

    const floatContent = (
      <div className='floater floater__dictionary'>
        <Icon name='close-gray' className='floater__close' />
        {header && <Text h3 className='floater__header'>{header}</Text>}
        {title && <Text h2 className='floater__title'>{title}</Text>}
        <Text paragraph>{text}</Text>
        {footer && <Text paragraph className='floater__footer'>{footer}</Text>}
      </div>);

    return (
      <ReactFloater
        component={floatContent}
        styles={FloaterStyles}
        open={open}
        placement={placement || 'right-start'}
        offset={20}
        title={t('testing')}
      >
        <div
          role='button'
          tabIndex={0}
          className={`floater__target ${open ? 'is-active' : ''}`}
          onClick={this.toggle}
        >
          <div className={`floater__underlined-text 
            ${open ? 'is-active is-dictionary-term' : ''}`}
          >
            {children}
          </div>
        </div>
      </ReactFloater>
    );
  }
}

export default withTranslation('dictionaryFloater')(DictionaryFloater);



// WEBPACK FOOTER //
// ./src/components/shared/DictionaryFloater.js